import {Button, Modal} from 'antd';
import {AiOutlineClose} from 'react-icons/ai';
import PropTypes from 'prop-types';
import React from 'react';
import {ExclamationCircleOutlined} from '@ant-design/icons';

export function confirmModalClose(onCancel) {
  Modal.confirm({
    title: 'Confirm',
    icon: <ExclamationCircleOutlined />,
    content: 'Are you sure to close the dialog?',
    okText: 'Yes',
    cancelText: 'No',
    onOk: onCancel,
  });
}

export default function ModalCloseConfirm({onCancel}) {
  const showModal = (e) => {
    e?.stopPropagation?.();
    e?.preventDefault?.();
    confirmModalClose(onCancel);
  };

  return (
    <span
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}>
      <Button type='text' onClick={showModal}>
        <AiOutlineClose />
      </Button>
    </span>
  );
}

ModalCloseConfirm.propTypes = {
  onCancel: PropTypes.func.isRequired,
};
